import { AccessPermissions } from 'core/enums';
import { convertArrayToObject } from 'coreOld/utils';

/**
 * Check if the route matches any of the resources.
 *
 * e.g. For route = '/support/request/list' will return true if the resources
 * object contains:
 *    - '/support/request/list' or
 *    - '/support/request/*' or
 *    - '/support/*' or
 *    - '/*'
 */
export const hasRoutePermission = (route: string, resources: string[]) => {
  if (!resources) {
    return false;
  }

  const resourcesObject = convertArrayToObject(resources);

  if (resourcesObject[route]) {
    return true;
  }

  // Split the route by slashes and reverse it
  const pathSplit = route.split('/').reverse();

  let partialRoute = route;

  for (const index in pathSplit) {
    const part = pathSplit[index];

    // Replace the last part of the route with a wildcard
    partialRoute = partialRoute.replace(new RegExp(`${part}.*`), '*');

    if (resourcesObject[partialRoute]) {
      return true;
    }
  }

  return false;
};

/**
 * Check if the user has the requested permissions.
 */
export const hasPermission = (
  requestedPermissions: AccessPermissions[],
  userPermissions: string[]
) => {
  if (!requestedPermissions) {
    return true;
  }

  return requestedPermissions?.every((permission) => userPermissions?.includes(permission));
};
